<template>
	<div class="service">
		<contents1 />
		<contents2 />
		<contents3 />
		<contents4 />
	</div>
</template>

<script>
import contents1 from '@/components/contents/service/Contents1'
import contents2 from '@/components/contents/service/Contents2'
import contents3 from '@/components/contents/service/Contents3'
import contents4 from '@/components/contents/service/Contents4'
export default {
	components: {
		contents1,
		contents2,
		contents3,
		contents4,
	},
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/Service.vue